<template>
  <div class="guide d-flex flex-grow">
    <v-card class="card">

      <v-row class="px-3 justify-center">
        <v-avatar color="#041E42" size="120">
        <v-icon color="#C8DCF0" size="60">laptop</v-icon>
        </v-avatar>
      </v-row>

      <v-row class="justify-center pt-6">
      <a href="https://schoolsnsw.sharepoint.com/:b:/s/EDConnectICTServiceDesk/Eb2uOmyEpahGk-I_J9bvg4kBsdceV7w6MDMfGy0yiexKyQ?e=2As5W8 " target="_blank">USER GUIDE</a>
      </v-row>

      <v-row class="justify-center">
      <v-subheader class="subheader">Managed Devices</v-subheader>
      </v-row>
    </v-card>
    <v-card class="card ml-6">
      <v-row class="px-3 justify-center">
        <v-avatar color="#041E42" size="120">
        <v-icon color="#C8DCF0" size="60">network_check</v-icon>
        </v-avatar>
      </v-row>

      <v-row class="justify-center pt-6">
      <a href="https://schoolsnsw.sharepoint.com/:b:/s/EDConnectICTServiceDesk/ESkUazkKjCJDlmehI0UrR9MBOJixULQmW-EsZyGOEuqWYg?e=xqwaxr" target="_blank">USER GUIDE</a>
      </v-row>

      <v-row class="justify-center">
      <v-subheader class="subheader">Network Usage</v-subheader>
      </v-row>
      </v-card>
  </div>
</template>
<script>
  export default {
    name: 'USAGEGUIDE',
  };
</script>

<style scoped>
::v-deep .available .theme--light.v-icon{
  color:#00A908 !important;
  font-size:20px;
}
.card{
  width:392px;
  max-height: 303px;
  padding:40px 20px;
  text-align: center;
  justify-content: center;
}
.card a{
    text-decoration:none;
    font-weight: bold;
    font-size: 14px;
    color: #407EC9;
}
::v-deep .unavailable .theme--light.v-icon{
  color:#B81237 !important;
  font-size:20px;
}

.subheader{
font-family: Arial;
font-style: normal;
font-weight: bold;
font-size: 24px;
height:40px;
line-height: 30px;
color: #041E42;
justify-content: center;
}
.guide{
  padding:0px;
  background: #FFFFFF;

}
</style>
